(function (window, document) {
  'use strict';

  var SELECTOR = '[data-track-like], .js-track-interaction';

  function buildPayload(el) {
    return {
      resource: el.dataset.resource || el.dataset.trackLike || 'page',
      resource_id: el.dataset.resourceId || el.dataset.trackLikeId || 'unknown',
      event: el.dataset.event || 'like_click',
      slot: el.dataset.slot || 'default',
      delta: Number(el.dataset.delta || '1') || 1
    };
  }

  function resolveCounterElement(el) {
    if (el.dataset.counterTarget) {
      return document.querySelector(el.dataset.counterTarget);
    }

    return el.querySelector('.js-counter-value');
  }

  function togglePending(el, isPending) {
    el.dataset.trackingPending = isPending ? 'true' : 'false';
    el.setAttribute('aria-busy', isPending ? 'true' : 'false');

    if ('disabled' in el) {
      el.disabled = isPending;
    }
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  async function handleLikeClick(el) {
    if (el.dataset.trackingPending === 'true') return;

    var tracking = window.StorefrontTracking || window.ProtoArcTracking;
    if (!tracking || typeof tracking.track !== 'function') return;

    togglePending(el, true);

    try {
      var payload = buildPayload(el);
      var result = await tracking.track('like_click', payload);
      var firstPartyResult = result.destinations && result.destinations.first_party;

      if (firstPartyResult && firstPartyResult.status === 'sent') {
        var counterEl = resolveCounterElement(el);
        var nextValue = firstPartyResult.data && firstPartyResult.data.value;

        if (counterEl && typeof nextValue !== 'undefined') {
          counterEl.textContent = String(nextValue);
        }

        emit('tracking:like-success', {
          element: el,
          payload: payload,
          result: result
        });
        return;
      }

      if (firstPartyResult && firstPartyResult.reason === 'login_required') {
        emit('tracking:like-login-required', {
          element: el,
          payload: payload,
          result: result
        });
        return;
      }

      emit('tracking:like-error', {
        element: el,
        payload: payload,
        result: result
      });
    } catch (error) {
      emit('tracking:like-error', {
        element: el,
        error: error
      });
    } finally {
      togglePending(el, false);
    }
  }

  function init() {
    document.addEventListener('click', function (event) {
      var el = event.target.closest(SELECTOR);
      if (!el) return;

      handleLikeClick(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
